import React, { useLayoutEffect, useRef, useState } from 'react';
import ModalView from '@/components/modal-view';
import { putExchangeCode } from '@/api/base';
import Header from '@/components/Header';
import { Container, ModalContainer } from './style';

import SuccessIcon from '../../img/sku/success.png';
import FailIcon from '../../img/sku/fail.png';
import SuccessFont from '../../img/sku/success-font.png';
import FailFont from '../../img/sku/fail-font.png';
import SuccessBtn from '../../img/sku/success-btn.png';
import FailBtn from '../../img/sku/fail-btn.png';
import ConfirmBtn from '@/img/sku/btn@2x.png';

const SkuExchage = () => {
  const [code, setCode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState('success');
  const [msg, setMsg] = useState('恭喜您成为市值风云VIP会员！');
  const containerRef = useRef();

  useLayoutEffect(() => {
    const clientWidth = document.body.clientWidth;
    const calcHeight = 737 / 375 * clientWidth;
    console.log(containerRef.current, 'containerRef.current')
    if (containerRef.current) {
      containerRef.current.style.height = Number(calcHeight).toFixed(0) + 'px'
    }
  }, [])

  const handleChange = (e) => {
    const value = e.target.value;
    setCode(value)
  }

  const handleSuccess = () => {
    setShowModal(false);
  }

  const handleConfirm = () => {
    if (!code.trim()) {
      return;
    }
    putExchangeCode({code}).then(res => {
      if (res.code !== '00') {
        setModalType('error');
        setMsg(res.msg);
        setCode('');
        setShowModal(true);
      } else {
        setModalType('success');
        setCode('');
        setMsg('恭喜您成为市值风云VIP会员！')
        setShowModal(true);
      }
    })
  }

  return (
    <Container className="sku-bg" ref={containerRef}>
      <Header title={'风云VIP权益兑换'} />
      <div className="input-wrap">
        <div className="input-container">
          <input value={code} className="sku-input" onChange={handleChange} placeholder="请输入兑换码" alt='' />
        </div>
      </div>
      <div onClick={handleConfirm} className="confirm-wrap">
        <img className="sku-confirm" src={ConfirmBtn} alt=''/>
      </div>
      <div className="footer-wrap">
        <div className='footer-wrap-title'>使用须知：</div>
        <div className="fotter-line">【权益介绍】<span className='desc-text'>兑换成功后可免费体验7天VIP会员，权益包括[付费研报]和[吾股异动]；</span></div>
        <div className="fotter-line">【填写要求】<span className='desc-text'>输入兑换码时，请注意字母大小写，不要有空格；</span></div>
        <div className="fotter-line">【使用时间】<span className='desc-text'>请在兑换码有效期内使用，如已过期不可使用；</span></div>
        <div className="fotter-line">【限领规则】<span className='desc-text'>活动有效期内，每个手机号仅限领1次，兑换码不可倒卖转让，不可兑换现金，请妥善保管；</span></div>
        <div className="fotter-line">【查看路径】<span className='desc-text'>市值风云App-我的-VIP会员中心</span></div>
      </div>

      <ModalView
        visible={showModal}
        content={
          <ModalContainer className="sku-modal">
            <div className="modal-container">
              <div className="img-wrap">
                <img className="img" src={modalType === 'success' ? SuccessIcon : FailIcon} alt=''/>
              </div>
              <div className="font-wrap">
                <img className="img" src={modalType === 'success' ? SuccessFont : FailFont}alt=''/>
              </div>
              <div className="label">{msg}</div>
              <div className="btn-wrap" onClick={handleSuccess}>
                <img className="img" src={modalType === 'success' ? SuccessBtn : FailBtn} alt=''/>
              </div>
            </div>
          </ModalContainer>
        }
      />
    </Container>
  )
}

export default SkuExchage;


// WEBPACK FOOTER //
// ./src/views/sku-exchange/index.js